import { openDB } from 'idb'

export function createIndexedDBAdapter(
  dbName,
  storeName,
  requestedVersion = 1
) {
  let dbPromise

  // Helper to delete DB if version mismatch occurs
  const deleteDBIfHigherVersion = async () => {
    if (!indexedDB.databases) return
    const dbInfo = (await indexedDB.databases()).find((d) => d.name === dbName)
    if (dbInfo?.version > requestedVersion) {
      console.warn(
        `Deleting DB ${dbName} because existing version ${dbInfo.version} > requested ${requestedVersion}`
      )
      await new Promise((resolve, reject) => {
        const delReq = indexedDB.deleteDatabase(dbName)
        delReq.onsuccess = resolve
        delReq.onerror = () => reject(delReq.error)
        delReq.onblocked = () => console.warn('Delete blocked')
      })
    }
  }

  const getDB = async () => {
    if (!dbPromise) {
      await deleteDBIfHigherVersion()

      dbPromise = openDB(dbName, requestedVersion, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName)
          }
        }
      })
    }
    return dbPromise
  }

  return {
    async get(key) {
      const db = await getDB()
      return db.get(storeName, key)
    },
    async set(key, value) {
      const db = await getDB()
      await db.put(storeName, value, key)
    },
    async remove(key) {
      const db = await getDB()
      await db.delete(storeName, key)
    },
    async all() {
      const db = await getDB()
      return db.getAll(storeName)
    },
    async has(key) {
      const db = await getDB()
      return (await db.get(storeName, key)) !== undefined
    },
    // Clear entire store
    async clear() {
      const db = await getDB()
      await db.clear(storeName)
    }
  }
}
